import type { SwampEvent } from './types';

export function teamTotals(events: SwampEvent[], teamNames: string[]): Record<string, number> {
   const scores: Record<string, number> = {};
   for (const teamName of teamNames) {
      scores[teamName] = events.reduce(
         (sum, event) => sum + (event.scores[teamName] ?? 0),
         0
      );
   }
   return scores;
}

export function winningTeamNames(scores: Record<string, number>): string[] {
   const values = Object.values(scores);
   if (values.length === 0) {
      return [];
   }

   const max = Math.max(...values);
   if (max <= 0) {
      return [];
   }

   return Object.keys(scores).filter((teamName) => scores[teamName] === max);
}
